<template>
    <div>
        <modal
            class="new-modal-default sweet-modal-alert"
            :name="modal_name"
            transition="nice-modal-fade"
            :delay="100"
            :height="500"
            :width="600"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="false"
            style="pointer-events:inherit !important" 
            v-bind:click-to-close="false"
        >
            <div class="v-modal-content d-flex flex-column justify-content-center align-items-center text-center" style="background-color: #fff !important;">
                <img src="/static/images/snake.svg" style="height: 16rem !important" />
                <span class="mt-5 fw-600" style="font-size: 24px; letter-spacing: 2px;">
                    WARNING
                </span>
                <span class="mt-5">
                    Are you sure you want to delete these files?
                </span>
                <div class="d-flex aligin-items-center justify-content-center mt-5">
                    <button
                        class="btn btn-new-danger btn-smm mr-2"
                        style="box-shadow: none;"
                        @click="hideSelf"
                    >NO</button>        
                    <button
                        type="button"
                        class="btn btn-new-green btn-smm ml-2"
                        style="box-shadow: none;"
                        @click="callReportDelete"
                    >YES</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
export default {
    props: ["modal_name"],
    methods: {
        callReportDelete() {
            this.$emit("callReportDelete");
            this.hideSelf();
        },
        hideSelf() {
            this.$modal.hide(this.modal_name);
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/alertModals/DeleteCallReports.vue